/**
 * Pequeñas Puntadas — purchase configuration.
 *
 * CHECKOUT_URL is the single destination used by every purchase button
 * (hero, offer, closing and mobile sticky bar).
 */
export const CHECKOUT_URL = 'https://pequenas-puntadas.impultienda.ar/checkout'

export const PRICE = {
  value: 24990,
  currency: 'ARS',
  label: '$24.990',
  compareAtLabel: '$49.990',
  perModelLead: '31 modelos por $24.990',
  perModelHighlight: 'Menos de $807 por modelo',
  perModelNote: 'Promedio dentro de la colección completa.',
  note: 'Pago único',
  delivery: 'Después del pago, accedés al enlace de descarga de todos los archivos.',
} as const

export const LAUNCH_LABEL = 'Descuento de lanzamiento'

/** Purchase CTA labels — every one goes to the checkout and shows the same price. */
export const CLOSING_BUY_LABEL = `Quiero los 31 modelos — ${PRICE.label}`
export const OFFER_BUY_LABEL = `Quiero la colección completa — ${PRICE.label}`
